import { Map, List } from "immutable";

import { ProjectMapper } from "features/planner/planner.mappers";
import { ACTIONS } from "features/planner/employee/employee.constants";
import { ACTIONS as PLANNER_ACTIONS } from "features/planner/planner.constants";

const initialState = Map();

export default (state = initialState, action) => {
  const { error, payload, type } = action;

  switch (type) {
    case ACTIONS.GET_EMPLOYEES_PROJECTS: {
      if (error) return state;
      return state.setIn(
        ["projectsByCard", action.cardId.toString()],
        Map(
          List(payload).map(project => [
            project.projectId.toString(),
            ProjectMapper.from(project),
          ]),
        ),
      );
    }
    case PLANNER_ACTIONS.GET_VIEW_GROUP_PROJECTS:
    case PLANNER_ACTIONS.GET_GROUP_PROJECTS: {
      if (error) return state;

      var gg = payload.reduce((result, project) => {
        (result[project.groupId.toString()] =
          result[project.groupId.toString()] || []).push(
          ProjectMapper.from(project),
        );
        return result;
      }, {});

      const aaa = Map(gg).map((a, b) => {
        return List(a).map(project => {
          return ProjectMapper.from(project);
        });
      });

      return state.setIn(["projectsByGroup"], aaa);
    }

    default:
      return state;
  }
};
